import React from 'react'

export default function TeamMember({ name, institution, image }) {
  // Use placeholder if no image provided
  const imageSrc = image || '/images/placeholder-profile.png'

  return (
    <div className="w-[140px] md:w-[15%] shadow-sm bg-[#739ea9] text-white">
      <img
        src={imageSrc}
        alt={name}
        className="w-full h-auto mx-auto"
      />
      <div className="p-2">
        <p className="text-sm">{name}</p>
        {institution && <p className="text-xs opacity-80">{institution}</p>}
      </div>
    </div>
  )
}
